@use "source/webComponent/theme" as *;

  .message {
    padding: 5px $spacine_px $spacine_px $spacine_px;
  }


